import { createContext, useContext, useState, useEffect } from 'react';
import { useAuth } from './AuthContext';

const ThemeContext = createContext();

export const useTheme = () => {
    const context = useContext(ThemeContext);
    if (!context) {
        throw new Error('useTheme must be used within a ThemeProvider');
    }
    return context;
};

export const ThemeProvider = ({ children }) => {
    const { user, updateUser } = useAuth();
    const [theme, setTheme] = useState('light');

    useEffect(() => {
        if (!user) return;

        const savedTheme =
            user?.preferences?.theme ??
            localStorage.getItem('islam101_theme') ??
            'light';

        setTheme(savedTheme);
        document.documentElement.classList.toggle('dark', savedTheme === 'dark');

        // keep localStorage in sync with user
        localStorage.setItem('islam101_theme', savedTheme);
    }, [user]);

    const toggleTheme = () => {
        const newTheme = theme === 'light' ? 'dark' : 'light';
        setTheme(newTheme);
        localStorage.setItem('islam101_theme', newTheme);
        document.documentElement.classList.toggle('dark', newTheme === 'dark');

        if (user) {
            updateUser({
                preferences: {
                    ...user.preferences,
                    theme: newTheme
                }
            });
        }
    };

    const value = {
        theme,
        toggleTheme,
        isDark: theme === 'dark'
    };

    return (
        <ThemeContext.Provider value={value}>
            {children}
        </ThemeContext.Provider>
    );
};